import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function FeaturedVideoSection() {
  return (
    <section className="bg-black py-24 md:py-40 overflow-hidden flex justify-center">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="relative w-full h-[60vh] md:h-[85vh] overflow-hidden"
      >
        <video
          className="absolute inset-0 w-full h-full object-cover"
          muted
          autoPlay
          loop
          playsInline
          preload="auto"
          src="https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260402_054547_9875cfc5-155a-4229-8ec8-b7ba7125cbf8.mp4"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent pointer-events-none" />

        {/* Bottom overlay content */}
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-12 lg:p-20 flex justify-center">
          <div className="w-full max-w-6xl flex flex-col md:flex-row justify-between items-start md:items-end gap-8">
            <div className="liquid-glass rounded-2xl p-6 md:p-8 max-w-md backdrop-blur-md">
              <div className="text-white/50 text-xs tracking-widest uppercase mb-3">
                [THE CORE PHILOSOPHY]
              </div>
              <p className="text-white text-sm md:text-base leading-relaxed font-light">
                History reveres the dead. We celebrate the living. Imagine if the greatest minds had a creative partner to give shape to their vision while they were alive. We are that partner. Building a great big beautiful tomorrow, today.
              </p>
            </div>
            
            <Link
              to="/contact"
              className="inline-block liquid-glass rounded-full px-8 py-4 text-white text-sm font-medium uppercase tracking-widest hover:bg-white/10 transition-colors backdrop-blur-md"
            >
              START A PROJECT.
            </Link>
          </div>
        </div>
      </motion.div>
    </section>
  );
}